const findOverviewSortValue = (currentColumn) => {
//current card view
  let arrow;
  let value;
  switch (true) {
  case currentColumn === 'report_r':
    arrow = false;
    value = '1';
    break;
  case currentColumn === 'report':
    arrow = true;
    value = '1';
    break;
  case currentColumn === 'grade_r':
    arrow = true;
    value = '2';
    break;
  case currentColumn === 'grade':
    arrow = false;
    value = '2';
    break;
  case currentColumn === 'component_r':
    arrow = true;
    value = '3';
    break;
  case currentColumn === 'component':
    arrow = false;
    value = '3';
    break;
  case currentColumn === 'security_r':
    arrow = true;
    value = '4';
    break;
  case currentColumn === 'security':
    arrow = false;
    value = '4';
    break;
  case currentColumn === 'license_r':
    arrow = true;
    value = '5';
    break;
  case currentColumn === 'license':
    arrow = false;
    value = '5';
    break;
  case currentColumn === 'litigator_r':
    arrow = true;
    value = '6';
    break;
  case currentColumn === 'litigator':
    arrow = false;
    value = '6';
    break;
  case currentColumn === 'policy_r':
    arrow = true;
    value = '7';
    break;
  case currentColumn === 'policy':
    arrow = false;
    value = '7';
    break;
  case currentColumn === 'uploaded_r':
    arrow = true;
    value = '8';
    break;
  case currentColumn === 'uploaded':
    arrow = false;
    value = '8';
    break;
  case currentColumn === 'owner_r':
    arrow = false;
    value = '9';
    break;
  case currentColumn === 'owner':
    arrow = true;
    value = '9';
    break;
  case currentColumn === 'scan_time_r':
    arrow = true;
    value = '10';
    break;
  case currentColumn === 'scan_time':
    arrow = false;
    value = '10';
    break;
  default:
    arrow = false;
    value = '8';
  }
  const obj = { isSort: arrow, sortValue: value };
  return obj;
};

const findOverviewSortColumn = (currentArrow, currentSortValue) => {
  //current list view
  //currentArrow: true -> up / false -> down
  let column;
  switch (true) {
  case currentArrow === true && currentSortValue === '1':
    column = 'report';
    break;
  case currentArrow === false && currentSortValue === '1':
    column = 'report_r';
    break;
  case currentArrow === true && currentSortValue === '2':
    column = 'grade_r';
    break;
  case currentArrow === false && currentSortValue === '2':
    column = 'grade';
    break;
  case currentArrow === true && currentSortValue === '3':
    column = 'component_r';
    break;
  case currentArrow === false && currentSortValue === '3':
    column = 'component';
    break;
  case currentArrow === true && currentSortValue === '4':
    column = 'security_r';
    break;
  case currentArrow === false && currentSortValue === '4':
    column = 'security';
    break;
  case currentArrow === true && currentSortValue === '5':
    column = 'license_r';
    break;
  case currentArrow === false && currentSortValue === '5':
    column = 'license';
    break;
  case currentArrow === true && currentSortValue === '6':
    column = 'litigator_r';
    break;
  case currentArrow === false && currentSortValue === '6':
    column = 'litigator';
    break;
  case currentArrow === true && currentSortValue === '7':
    column = 'policy_r';
    break;
  case currentArrow === false && currentSortValue === '7':
    column = 'policy';
    break;
  case currentArrow === true && currentSortValue === '8':
    column = 'uploaded_r';
    break;
  case currentArrow === false && currentSortValue === '8':
    column = 'uploaded';
    break;
  case currentArrow === true && currentSortValue === '9':
    column = 'owner';
    break;
  case currentArrow === false && currentSortValue === '9':
    column = 'owner_r';
    break;
  case currentArrow === true && currentSortValue === '10':
    column = 'scan_time_r';
    break;
  case currentArrow === false && currentSortValue === '10':
    column = 'scan_time';
    break;
  default:
    column = 'uploaded';
    break;
  }
  return column;
};

const findOverviewProjectSortValue = (currentColumn) => {
  //current card view
  let arrow;
  let value;
  switch (true) {
  case currentColumn === 'project_r':
    arrow = false;
    value = '1';
    break;
  case currentColumn === 'project':
    arrow = true;
    value = '1';
    break;
  case currentColumn === 'version_r':
    arrow = true;
    value = '2';
    break;
  case currentColumn === 'version':
    arrow = false;
    value = '2';
    break;
  case currentColumn === 'file_r':
    arrow = true;
    value = '3';
    break;
  case currentColumn === 'file':
    arrow = false;
    value = '3';
    break;
  case currentColumn === 'grade_r':
    arrow = true;
    value = '4';
    break;
  case currentColumn === 'grade':
    arrow = false;
    value = '4';
    break;
  case currentColumn === 'component_r':
    arrow = true;
    value = '5';
    break;
  case currentColumn === 'component':
    arrow = false;
    value = '5';
    break;
  case currentColumn === 'security_r':
    arrow = true;
    value = '6';
    break;
  case currentColumn === 'security':
    arrow = false;
    value = '6';
    break;
  case currentColumn === 'license_r':
    arrow = true;
    value = '7';
    break;
  case currentColumn === 'license':
    arrow = false;
    value = '7';
    break;
  case currentColumn === 'litigator_r':
    arrow = true;
    value = '8';
    break;
  case currentColumn === 'litigator':
    arrow = false;
    value = '8';
    break;
  case currentColumn === 'policy_r':
    arrow = true;
    value = '9';
    break;
  case currentColumn === 'policy':
    arrow = false;
    value = '9';
    break;
  default:
    arrow = false;
    value = '10';
  }
  const obj = { isSort: arrow, sortValue: value };
  return obj;
};

const findOverviewProjectSortColumn = (currentArrow, currentSortValue) => {
  //current list view
  //currentArrow: true -> up / false -> down
  let column;
  switch (true) {
  case currentArrow === true && currentSortValue === '1':
    column = 'project';
    break;
  case currentArrow === false && currentSortValue === '1':
    column = 'project_r';
    break;
  case currentArrow === true && currentSortValue === '2':
    column = 'version_r';
    break;
  case currentArrow === false && currentSortValue === '2':
    column = 'version';
    break;
  case currentArrow === true && currentSortValue === '3':
    column = 'file_r';
    break;
  case currentArrow === false && currentSortValue === '3':
    column = 'file';
    break;
  case currentArrow === true && currentSortValue === '4':
    column = 'grade_r';
    break;
  case currentArrow === false && currentSortValue === '4':
    column = 'grade';
    break;
  case currentArrow === true && currentSortValue === '5':
    column = 'component_r';
    break;
  case currentArrow === false && currentSortValue === '5':
    column = 'component';
    break;
  case currentArrow === true && currentSortValue === '6':
    column = 'security_r';
    break;
  case currentArrow === false && currentSortValue === '6':
    column = 'security';
    break;
  case currentArrow === true && currentSortValue === '7':
    column = 'license_r';
    break;
  case currentArrow === false && currentSortValue === '7':
    column = 'license';
    break;
  case currentArrow === true && currentSortValue === '8':
    column = 'litigator_r';
    break;
  case currentArrow === false && currentSortValue === '8':
    column = 'litigator';
    break;
  case currentArrow === true && currentSortValue === '9':
    column = 'policy_r';
    break;
  case currentArrow === false && currentSortValue === '9':
    column = 'policy';
    break;
  default:
    column = 'uploaded';
    break;
  }
  return column;
};

const findComponentProjectSortValue = (currentColumn) => {
  //current card view
  let arrow;
  let value;
  switch (true) {
  case currentColumn === 'project_r':
    arrow = false;
    value = '1';
    break;
  case currentColumn === 'project':
    arrow = true;
    value = '1';
    break;
  case currentColumn === 'version_r':
    arrow = true;
    value = '2';
    break;
  case currentColumn === 'version':
    arrow = false;
    value = '2';
    break;
  case currentColumn === 'file_r':
    arrow = true;
    value = '3';
    break;
  case currentColumn === 'file':
    arrow = false;
    value = '3';
    break;
  case currentColumn === 'component_r':
    arrow = true;
    value = '4';
    break;
  case currentColumn === 'component':
    arrow = false;
    value = '4';
    break;
  case currentColumn === 'most_found_r':
    arrow = true;
    value = '5';
    break;
  case currentColumn === 'most_found':
    arrow = false;
    value = '5';
    break;
  case currentColumn === 'most_vulnerable_r':
    arrow = true;
    value = '6';
    break;
  case currentColumn === 'most_vulnerable':
    arrow = false;
    value = '6';
    break;
  default:
    arrow = false;
    value = '7';
  }
  const obj = { isSort: arrow, sortValue: value };
  return obj;
};

const findComponentProjectSortColumn = (currentArrow, currentSortValue) => {
  //current list view
  //currentArrow: true -> up / false -> down
  let column;
  switch (true) {
  case currentArrow === true && currentSortValue === '1':
    column = 'project';
    break;
  case currentArrow === false && currentSortValue === '1':
    column = 'project_r';
    break;
  case currentArrow === true && currentSortValue === '2':
    column = 'version_r';
    break;
  case currentArrow === false && currentSortValue === '2':
    column = 'version';
    break;
  case currentArrow === true && currentSortValue === '3':
    column = 'file_r';
    break;
  case currentArrow === false && currentSortValue === '3':
    column = 'file';
    break;
  case currentArrow === true && currentSortValue === '4':
    column = 'component_r';
    break;
  case currentArrow === false && currentSortValue === '4':
    column = 'component';
    break;
  case currentArrow === true && currentSortValue === '5':
    column = 'most_found_r';
    break;
  case currentArrow === false && currentSortValue === '5':
    column = 'most_found';
    break;
  case currentArrow === true && currentSortValue === '6':
    column = 'most_vulnerable_r';
    break;
  case currentArrow === false && currentSortValue === '6':
    column = 'most_vulnerable';
    break;
  default:
    column = 'uploaded';
    break;
  }
  return column;
};

const findSecurityProjectSortValue = (currentColumn) => {
  //current card view
  let arrow;
  let value;
  switch (true) {
  case currentColumn === 'project_r':
    arrow = false;
    value = '1';
    break;
  case currentColumn === 'project':
    arrow = true;
    value = '1';
    break;
  case currentColumn === 'version_r':
    arrow = true;
    value = '2';
    break;
  case currentColumn === 'version':
    arrow = false;
    value = '2';
    break;
  case currentColumn === 'file_r':
    arrow = true;
    value = '3';
    break;
  case currentColumn === 'file':
    arrow = false;
    value = '3';
    break;
  case currentColumn === 'security_r':
    arrow = true;
    value = '4';
    break;
  case currentColumn === 'security':
    arrow = false;
    value = '4';
    break;
  case currentColumn === 'most_found_r':
    arrow = true;
    value = '5';
    break;
  case currentColumn === 'most_found':
    arrow = false;
    value = '5';
    break;
  case currentColumn === 'most_vulnerable_r':
    arrow = true;
    value = '6';
    break;
  case currentColumn === 'most_vulnerable':
    arrow = false;
    value = '6';
    break;
  default:
    arrow = false;
    value = '7';
  }
  const obj = { isSort: arrow, sortValue: value };
  return obj;
};

const findSecurityProjectSortColumn = (currentArrow, currentSortValue) => {
  //current list view
  //currentArrow: true -> up / false -> down
  let column;
  switch (true) {
  case currentArrow === true && currentSortValue === '1':
    column = 'project';
    break;
  case currentArrow === false && currentSortValue === '1':
    column = 'project_r';
    break;
  case currentArrow === true && currentSortValue === '2':
    column = 'version_r';
    break;
  case currentArrow === false && currentSortValue === '2':
    column = 'version';
    break;
  case currentArrow === true && currentSortValue === '3':
    column = 'file_r';
    break;
  case currentArrow === false && currentSortValue === '3':
    column = 'file';
    break;
  case currentArrow === true && currentSortValue === '4':
    column = 'security_r';
    break;
  case currentArrow === false && currentSortValue === '4':
    column = 'security';
    break;
  case currentArrow === true && currentSortValue === '5':
    column = 'most_found_r';
    break;
  case currentArrow === false && currentSortValue === '5':
    column = 'most_found';
    break;
  case currentArrow === true && currentSortValue === '6':
    column = 'most_vulnerable_r';
    break;
  case currentArrow === false && currentSortValue === '6':
    column = 'most_vulnerable';
    break;
  default:
    column = 'uploaded';
    break;
  }
  return column;
};

const findLicenseProjectSortValue = (currentColumn) => {
  //current card view
  let arrow;
  let value;
  switch (true) {
  case currentColumn === 'project_r':
    arrow = false;
    value = '1';
    break;
  case currentColumn === 'project':
    arrow = true;
    value = '1';
    break;
  case currentColumn === 'version_r':
    arrow = true;
    value = '2';
    break;
  case currentColumn === 'version':
    arrow = false;
    value = '2';
    break;
  case currentColumn === 'file_r':
    arrow = true;
    value = '3';
    break;
  case currentColumn === 'file':
    arrow = false;
    value = '3';
    break;
  case currentColumn === 'license_r':
    arrow = true;
    value = '4';
    break;
  case currentColumn === 'license':
    arrow = false;
    value = '4';
    break;
  case currentColumn === 'litigator_r':
    arrow = true;
    value = '5';
    break;
  case currentColumn === 'litigator':
    arrow = false;
    value = '5';
    break;
  default:
    arrow = false;
    value = '6';
  }
  const obj = { isSort: arrow, sortValue: value };
  return obj;
};

const findLicenseProjectSortColumn = (currentArrow, currentSortValue) => {
  //current list view
  //currentArrow: true -> up / false -> down
  let column;
  switch (true) {
  case currentArrow === true && currentSortValue === '1':
    column = 'project';
    break;
  case currentArrow === false && currentSortValue === '1':
    column = 'project_r';
    break;
  case currentArrow === true && currentSortValue === '2':
    column = 'version_r';
    break;
  case currentArrow === false && currentSortValue === '2':
    column = 'version';
    break;
  case currentArrow === true && currentSortValue === '3':
    column = 'file_r';
    break;
  case currentArrow === false && currentSortValue === '3':
    column = 'file';
    break;
  case currentArrow === true && currentSortValue === '4':
    column = 'license_r';
    break;
  case currentArrow === false && currentSortValue === '4':
    column = 'license';
    break;
  case currentArrow === true && currentSortValue === '5':
    column = 'litigator_r';
    break;
  case currentArrow === false && currentSortValue === '5':
    column = 'litigator';
    break;
  default:
    column = 'uploaded';
    break;
  }
  return column;
};

const findPolicyProjectSortValue = (currentColumn) => {
  //current card view
  let arrow;
  let value;
  switch (true) {
  case currentColumn === 'project_r':
    arrow = false;
    value = '1';
    break;
  case currentColumn === 'project':
    arrow = true;
    value = '1';
    break;
  case currentColumn === 'version_r':
    arrow = true;
    value = '2';
    break;
  case currentColumn === 'version':
    arrow = false;
    value = '2';
    break;
  case currentColumn === 'file_r':
    arrow = true;
    value = '3';
    break;
  case currentColumn === 'file':
    arrow = false;
    value = '3';
    break;
  case currentColumn === 'policy_r':
    arrow = true;
    value = '4';
    break;
  case currentColumn === 'policy':
    arrow = false;
    value = '4';
    break;
  case currentColumn === 'policy_component_r':
    arrow = true;
    value = '5';
    break;
  case currentColumn === 'policy_component':
    arrow = false;
    value = '5';
    break;
  case currentColumn === 'policy_security_r':
    arrow = true;
    value = '6';
    break;
  case currentColumn === 'policy_security':
    arrow = false;
    value = '6';
    break;
  case currentColumn === 'policy_license_r':
    arrow = true;
    value = '7';
    break;
  case currentColumn === 'policy_license':
    arrow = false;
    value = '7';
    break;
  case currentColumn === 'policy_litigator_r':
    arrow = true;
    value = '8';
    break;
  case currentColumn === 'policy_litigator':
    arrow = false;
    value = '8';
    break;
  default:
    arrow = false;
    value = '9';
  }
  const obj = { isSort: arrow, sortValue: value };
  return obj;
};

const findPolicyProjectSortColumn = (currentArrow, currentSortValue) => {
  //current list view
  //currentArrow: true -> up / false -> down
  let column;
  switch (true) {
  case currentArrow === true && currentSortValue === '1':
    column = 'project';
    break;
  case currentArrow === false && currentSortValue === '1':
    column = 'project_r';
    break;
  case currentArrow === true && currentSortValue === '2':
    column = 'version_r';
    break;
  case currentArrow === false && currentSortValue === '2':
    column = 'version';
    break;
  case currentArrow === true && currentSortValue === '3':
    column = 'file_r';
    break;
  case currentArrow === false && currentSortValue === '3':
    column = 'file';
    break;
  case currentArrow === true && currentSortValue === '4':
    column = 'policy_r';
    break;
  case currentArrow === false && currentSortValue === '4':
    column = 'policy';
    break;
  case currentArrow === true && currentSortValue === '5':
    column = 'policy_component_r';
    break;
  case currentArrow === false && currentSortValue === '5':
    column = 'policy_component';
    break;
  case currentArrow === true && currentSortValue === '6':
    column = 'policy_security_r';
    break;
  case currentArrow === false && currentSortValue === '6':
    column = 'policy_security';
    break;
  case currentArrow === true && currentSortValue === '7':
    column = 'policy_license_r';
    break;
  case currentArrow === false && currentSortValue === '7':
    column = 'policy_license';
    break;
  case currentArrow === true && currentSortValue === '8':
    column = 'policy_litigator_r';
    break;
  case currentArrow === false && currentSortValue === '8':
    column = 'policy_litigator';
    break;
  default:
    column = 'uploaded';
    break;
  }
  return column;
};

export {
  findOverviewSortValue,
  findOverviewSortColumn,
  findOverviewProjectSortValue,
  findOverviewProjectSortColumn,
  findComponentProjectSortValue,
  findComponentProjectSortColumn,
  findSecurityProjectSortValue,
  findSecurityProjectSortColumn,
  findLicenseProjectSortValue,
  findLicenseProjectSortColumn,
  findPolicyProjectSortValue,
  findPolicyProjectSortColumn,
};
